export default "__VITE_ASSET__B8Xx429C__"